import {createAction} from 'redux-act';

export const GET_ORDERS = createAction('ordersV2/GET_ORDERS');
export const SET_NEXT_PAGE = createAction('ordersV2/SET_NEXT_PAGE');
export const ORDERS_UNMOUNT = createAction('ordersV2/ORDERS_UNMOUNT');
export const SET_FILTER = createAction('ordersV2/SET_FILTER');
export const SET_SORTING = createAction('ordersV2/SET_SORTING');
export const SET_SEARCH = createAction('ordersV2/SET_SEARCH');
export const CLEAR_ORDERS = createAction('ordersV2/CLEAR_ORDERS');
export const CHANGE_REFUNDS_HISTORY = createAction(
  'ordersV2/CHANGE_REFUNDS_HISTORY'
);
export const CHANGE_STATUS_HISTORY = createAction(
  'ordersV2/CHANGE_STATUS_HISTORY'
);
export const CHANGE_STATUS_HISTORY_SUCCESS = createAction(
  'ordersV2/CHANGE_STATUS_HISTORY_SUCCESS'
);
export const REFRESH_ORDERS = createAction('ordersV2/REFRESH_ORDERS');
export const SET_ORDERS = createAction('ordersV2/SET_ORDERS');
export const SET_ORDERS_EMPTY = createAction('ordersV2/SET_ORDERS_EMPTY');
export const CHANGE_ORDER_INFO = createAction('ordersV2/CHANGE_ORDER_INFO');
export const GET_ORDER = createAction('ordersV2/GET_ORDER');
export const GET_ORDER_SUCCESS = createAction('ordersV2/GET_ORDER_SUCCESS');
export const GET_LOCATION_ID_DATA = createAction(
  'ordersV2/GET_LOCATION_ID_DATA'
);
export const GET_LOCATION_ID_DATA_SUCCESS = createAction(
  'ordersV2/GET_LOCATION_ID_DATA_SUCCESS'
);
export const GET_CLOUD_PRINT_CONFIGURATIONS = createAction(
  'ordersV2/GET_CLOUD_PRINT_CONFIGURATIONS'
);
export const GET_CLOUD_PRINT_CONFIGURATIONS_SUCCESS = createAction(
  'ordersV2/GET_CLOUD_PRINT_CONFIGURATIONS'
);
export const UPDATE_CLOUD_PRINT_CONFIGURATIONS = createAction(
  'ordersV2/UPDATE_CLOUD_PRINT_CONFIGURATIONS'
);
export const CLEAR_CLOUD_PRINT_CONFIGURATIONS = createAction(
  'ordersV2/CLEAR_CLOUD_PRINT_CONFIGURATIONS'
);
export const PATCH_LOCATION_ACTION = createAction('ordersV2/PATCH_LOCATION');
export const SEND_TEST_ORDER = createAction('ordersV2/SEND_TEST_ORDER');
export const SEND_TEST_ORDER_SUCCESS = createAction(
  'ordersV2/SEND_TEST_ORDER_SUCCESS'
);
export const CLEAR_FILTERS = createAction('ordersV2/CLEAR_FILTERS');
export const OPEN_STATUS_CHANGE_MODAL = createAction(
  'globalNotifications/OPEN_STATUS_CHANGE_MODAL'
);
export const TURN_OFF_COMPLETED_NOTIFICATION = createAction(
  'globalNotifications/TURN_OFF_COMPLETED_NOTIFICATION'
);

export const OPEN_CANCELLATION_CONFIRMATION_MODAL = createAction(
  'ordersV2/OPEN_CANCELLATION_CONFIRMATION_MODAL'
);
